import styled from '@emotion/styled';

export const ActionIconStyles = styled('div')`
  display: inline-block;
  background: transparent;
  border-radius: 2rem;
  opacity: 1;
`;
